import React, { useState } from 'react';
import { Card, Input, Button, Alert } from 'antd';
import { useAuth } from '../auth/AuthContext';
import logo from '../assets/logo.svg';  // Updated import path to match your structure

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f0f2f5',
      padding: '20px'
    }}>
      <Card style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginBottom: '24px' 
        }}>
          <img 
            src={logo}  // Using the imported logo
            alt="Logo"
            style={{ 
              width: '256px', 
              height: '90px', 
              objectFit: 'contain' 
            }}
          />
        </div>

        
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: '16px' }}
          />
        )}
        
        <form onSubmit={async (e) => {
          e.preventDefault();
          setError('');
          setLoading(true);
          try {
            await login(username, password);
          } catch (err) {
            setError('Invalid username or password');
          } finally {
            setLoading(false);
          }
        }}>
          <div style={{ marginBottom: '16px' }}>
            <Input
              size="large"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          
          <div style={{ marginBottom: '24px' }}>
            <Input.Password
              size="large"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            style={{ width: '100%' }}
          >
            Log In
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default LoginPage;